import Members from '../members'
import Collection from '../collection'
import Reviews from '../reviews'
import Title from '../title'
import FloatPanel from './float-panel'

export default function Referral({ studio, posts, reviews }) {
  const t = useI18n()
  const renderBanner = () => {
    if (!studio.bannerUrl) return <div className='w-full h-full bg-gray-100'></div>
    return <div className='w-full h-[10rem] flex relative mb-9'>
      <C.Image
        className='w-full h-full'
        src={ studio.bannerUrl }
      />
    </div>
  }

  return (
    <div>
      { renderBanner() }
      <div className='container flex flex-row space-x-10 mb-16'>
        <div className='flex-1'>
          <div className='lg:hidden mt-[-100px] mb-10 relative'>
            <FloatPanel studio={ studio }/>
          </div>
          { !!studio.showableStylists.length && (<>
            <Title>{ t('page:studioId.stylist') }</Title>
            <Members studio={ studio } />
            <Hr />
          </>)}
          <Collection studio={ studio } posts={ posts }/>
          <Reviews studio={ studio } reviews={ reviews } />
        </div>
        <div className='hidden lg:block relative -translate-y-[100px]'>
          <div className='sticky top-[12rem]'>
            <FloatPanel studio={ studio }/>
          </div>
        </div>
      </div>
    </div>
  )
}

const Hr = () => (
  <div className='py-5'>
    <div className=''/>
  </div>
)
